import { render, staticRenderFns } from "./article-title.vue?vue&type=template&id=30932ade&lang=pug&"
import script from "./article-title.vue?vue&type=script&lang=js&"
export * from "./article-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports